import type { TFunction } from "i18next";
import type { Language } from "../../shared/types/websiteTypes";

import {
  getActualVisitorsModalInitialText,
  getOrdersAndRegistrationsInitialText,
} from "../web-utils";

export const getDefaultSettings = (
  language: Language,
  t: TFunction<"translation", undefined, "translation">,
) => {
  return {
    lastOrders: {
      text: t(getOrdersAndRegistrationsInitialText(true, language)),
      maxLastDays: 5,
      minOrders: 5,
      maxLastOrders: 10,
      showCustomerOwnOrders: true,
    },
    lastRegistrations: {
      text: t(getOrdersAndRegistrationsInitialText(false, language)),
      maxLastDays: 5,
      minRegistrations: 5,
      maxLastRegistrations: 10,
      showCustomerOwnRegistrations: true,
    },
    actualVisitors: {
      minVisitors: 10,
      text: t(getActualVisitorsModalInitialText(language)),
    },
    visitorSummary: {
      text: t(getActualVisitorsModalInitialText(language)),
      maxLastDays: 7,
      minVisitors: 20,
    },
    heureka: {
      minReviews: 1,
      minReviewStars: 4,
    },
    zboziCompanyRating: {
      minReviews: 1,
    },
    individual: {
      addLink: false,
      name: "",
      text: "",
      linkAsButton: false,
      openLinkInNewWindow: false,
    },
    shoptetLastOrders: {},
    shopifyLastOrders: {},
    eshopRychleLastOrders: {},
    shoptetCouponCode: {},
    spolehlivaRecenzeShopRating: {
      minReviews: 1,
      minReviewStars: 4,
    },
    googleReviews: {
      text: t(getActualVisitorsModalInitialText(language)),
      minReviews: 1,
      minReviewStars: 4,
    },
    trustpilotReviews: {
      text: t(getActualVisitorsModalInitialText(language)),
      minReviews: 1,
      minReviewStars: 4,
    },
  };
};
